import type { ReactNode } from 'react';
import type { FetchState } from '../lib/useFetch';

export const Note = ({ children, tone }: { children: ReactNode; tone?: 'error' }) => (
  <div
    style={{
      padding: '32px 0',
      textAlign: 'center',
      fontSize: 13,
      color: tone === 'error' ? 'var(--status-error-ink)' : 'var(--p-muted-fg)',
    }}
  >
    {children}
  </div>
);

/** Render-prop boundary for an async fetch: loading / error / empty / data. */
export function Async<T>({
  state,
  children,
  isEmpty,
  emptyLabel = 'Nothing here yet.',
}: {
  state: FetchState<T>;
  children: (data: T) => ReactNode;
  isEmpty?: (data: T) => boolean;
  emptyLabel?: string;
}) {
  if (state.loading) return <Note>Loading…</Note>;
  if (state.error) return <Note tone="error">Couldn't load — {state.error}</Note>;
  if (state.data === undefined) return <Note>No data.</Note>;
  if (isEmpty?.(state.data)) return <Note>{emptyLabel}</Note>;
  return <>{children(state.data)}</>;
}
